export default __webpack_public_path__ + "static/media/correct16.860ce4db.mp3";